// @ts-nocheck 5f8e8d73
import * as actionTypes from './wixCodeIDEActionTypes';

const overrideWixCodeIDE = (overrides) => ({
  type: actionTypes.OVERRIDE_WIX_CODE_IDE,
  overrides,
});

export { overrideWixCodeIDE };
